import { LazyLoadComponentConfig, ProfileDetailRequest } from '@se-po/shared-util'
import { SeFeMenuOptions } from 'se-fe-menu'

export const PROFILE_SIDE_PANEL_DETAILS = {
  memberships: {
    import: () => import('@se-po/shared-feature-profile-memberships'),
    component: 'ProfileMembershipDetailComponent',
    module: 'SharedFeatureProfileMembershipsModule',
  },
  group: {
    import: () => import('@se-po/shared-feature-profile-groups'),
    component: 'ProfileGroupDetailComponent',
    module: 'SharedFeatureProfileGroupsModule',
  },
  registration: {
    import: () => import('@se-po/shared-feature-profile-registrations'),
    component: 'ProfileRegistrationDetailComponent',
    module: 'SharedFeatureProfileRegistrationsModule',
  },
} as const satisfies Record<string, LazyLoadComponentConfig>

export type ProfileSidePanelDetailType = keyof typeof PROFILE_SIDE_PANEL_DETAILS

export type ProfileSidePanelDetail = ProfileDetailRequest<ProfileSidePanelDetailType, SeFeMenuOptions>

export const isProfileSidePanelDetailType = (type: string): type is ProfileSidePanelDetailType =>
  Object.prototype.hasOwnProperty.call(PROFILE_SIDE_PANEL_DETAILS, type)
